import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/roles-rights',
    name: 'roles-rights',
    component: () => import('./roles/pages/RolesRightsPage.vue')
  },
  {
    path: '/admin/roles-rights/create',
    name: 'roles-rights-create',
    component: () => import('./roles/pages/RolesRightsFormPage.vue')
  },
  {
    path: '/admin/roles-rights/:id/edit',
    name: 'roles-rights-edit',
    component: () => import('./roles/pages/RolesRightsFormPage.vue'),
    props: true
  },
  {
    path: '/admin/roles-rights/:id',
    name: 'roles-rights-view',
    component: () => import('./roles/pages/RolesRightsViewPage.vue'),
    props: true
  },
  {
    path: '/admin/resellers',
    name: 'resellers',
    component: () => import('./resellers/pages/ResellersPage.vue')
  },
  {
    path: '/admin/resellers/:id/edit',
    name: 'resellers-edit',
    component: () => import('./resellers/pages/ResellerEditPage.vue'),
    props: true
  },
  {
    path: '/admin/countries',
    name: 'countries',
    component: () => import('./countries/pages/CountriesPage.vue')
  },
  {
    path: '/admin/customer-sip-servers',
    name: 'customer-sip-servers',
    component: () => import('./customer-sip-servers/pages/CustomerSipServersPage.vue')
  },
  {
    path: '/admin/carrier-sip-servers',
    name: 'carrier-sip-servers',
    component: () => import('./carrier-sip-servers/pages/CarrierSipServersPage.vue')
  },
  {
    path: '/admin/holidays',
    name: 'holidays',
    component: () => import('./holidays/pages/HolidaysPage.vue')
  },
  {
    path: '/admin/holidays/:id/edit',
    name: 'holidays-edit',
    component: () => import('./holidays/pages/HolidayEditPage.vue'),
    props: true
  },
  {
    path: '/admin/provisioning',
    name: 'provisioning',
    component: () => import('./provisioning/pages/ProvisioningPage.vue')
  },
  {
    path: '/admin/provisioning/:id/edit',
    name: 'device-profiles-edit',
    component: () => import('./provisioning/pages/DeviceProfileEditPage.vue'),
    props: true
  },
  {
    path: '/portal-settings',
    name: 'portal-settings',
    component: () => import('./resellers/pages/PortalSettingsPage.vue')
  },
  {
    path: '/admin/job-queues',
    name: 'job-queues',
    component: () => import('./job-queues/pages/JobQueuesPage.vue')
  },
  {
    path: '/admin/job-queues/jobs/:id',
    name: 'job-queues-detail',
    component: () => import('./job-queues/pages/JobQueueDetailPage.vue'),
    props: true
  }
]
